import React, { useEffect, useState } from 'react'
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import { useFormik } from 'formik';
import { Form, useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import { GetAccess, GetNotUseRole } from '../../../../Components/Utils/roles';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { NuDate } from '../../../../Components/Utils/Input';
import NuDateFormate, { formatDate } from '../../../../Components/Utils/NuDate';
import axiosInstance from '../../../../Services/axiosCommon';
import CloseIcon from '../../../../Components/Icons/Close';
import TicketsLayout from '../TicketsLayout';
import MobileClientTicketIndex from '../../../Mobile/Tickets/ClientTicket/MobileClientTicketIndex';
import ImportClientTicket from './ImportSupportTicket';
import MultiEditClientTicket from './MultiEditSupportTicket';
import ImportSupportTicket from './ImportSupportTicket';
import MultiEditSupportTicket from './MultiEditSupportTicket';
import MobileSupportTicketIndex from '../../../Mobile/Tickets/SupportTicket/MobileSupportTicketIndex';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import UseDropDown from '../../../../Components/Hooks/useDropDown';



function SupportTicketsIndex() {
  const { officeId } = useParams();
  const [showFilterDialog, setShowFilterDialog] = useState(false);


  const { value: TicketType,getData:refTicketType } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Ticket_Type",showFilterDialog
  );  
  
  const { value: Priority,getData:refPriority } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "priority",showFilterDialog
  );  
  
  const { value: Status,getData:refStatus } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Status_Support_Tickets",showFilterDialog
  );

  const { value: Category,getData:refCategory } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Category_Support_Tickets",showFilterDialog
  );

    const { data: user } = UseDropDown(`/user/new-drop-down`);
  
  const [screenSize, setScreenSize] = useState({
         width: window.innerWidth,
       });
     
       useEffect(() => {
         const handleResize = () => {
           setScreenSize({
             width: window.innerWidth,
           });
         };
     
         window.addEventListener("resize", handleResize);
     
         return () => {
           window.removeEventListener("resize", handleResize);
         };
       }, []);

 const location = useLocation();
 const currentPage= location.state?.currentPage
 const searchQuery= location.state?.searchQuery
 const [page, setPage] = useState(currentPage||1)
 const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
 const state = location.state;
 const [filter, setFilter] = useState(
   state?.approvalStatus || state?.category ? true : false
 );
   const [filterProps, setFilterProps] = useState({
 
    status:"",
    startDateTo:"",
    startDateFrom:"",
    endDateFrom:"",
    endDateTo:"",
    priority:"",
    category:"",
    assigneeId:"",
   });
 const [params, setParams] = useState({
   page: page,
   per_page: pageCount,
   search:searchQuery||"",

   status:"",
   startDateTo:"",
   startDateFrom:"",
   endDateFrom:"",
   endDateTo:"",
   priority:"",
   category:"",
   assigneeId:"",
   approvalStatus:state?.approvalStatus? state.approvalStatus :"",
   category:state?.category? state.category :"",
 });

 const clearFilter = ()=> {
   setParams({...params,status:"", startDateFrom:"", startDateTo:"",endDateFrom:"", endDateTo:"",priority:"",category:"",assigneeId:"",})
   formik.values.status=""
   formik.values.startDateFrom=""
   formik.values.startDateTo=""
   formik.values.endDateFrom=""
   formik.values.endDateTo=""
   formik.values.priority=""
   formik.values.category=""
   formik.values.assigneeId=""




     setFilter(false)
 }

 const formik = useFormik({
   enableReinitialize: true,
   initialValues: filterProps,
   validateOnChange: false,
   validateOnBlur: false,
   validationSchema: yup.object({
     // email: yup.string().required('Email is required!'),
   }),
   onSubmit: async (value, { resetForm }) => {
      await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting

     setParams({...params,status:value.status, startDateFrom:value.startDateFrom, startDateTo:value.startDateTo, endDateFrom:value.endDateFrom, endDateTo:value.endDateTo,priority:value.priority,category:value.category,assigneeId:value.assigneeId})
     closeFilterDialog();
     setFilter(true)
     setFilterProps({
      status:"",
    startDateTo:"",
    startDateFrom:"",
    endDateFrom:"",
    endDateTo:"",
    priority:"",
    category:"",
    assigneeId:"",
     });
   }
 })

 const { data, totalCount, getData,dataLoading } = UseGetDataSearch( `/tickets/assigned-tickets-listing`,params);

 const defaultHeader = [
  {
    title: "Ref.",
    width: "12.85%",
    isLink: true,
    id: "assignedTicketId",
    link: `/tickets/support-tickets/view/`,
    field: "refNumber",
    textAlign: "left",
    rowAlign: "left",
  },
 //  {
 //    title: "Type",
 //    width: "10%",
 //    isLink: true,
 //    id: "clientTicketId",
 //    link: `/testingAndcommisioning/schedules/view/`,
 
 //    field: "Type",
 //    textAlign: "left",
 //    rowAlign: "left",  
 //  },
 {
  title: "Ticket Date",
  width: "12.85%",
  field: "date",
  isLink: true,
  id: "assignedTicketId",
  link: `/tickets/support-tickets/view/`,
  textAlign: "left",
  rowAlign: "left",
},
 GetNotUseRole("client") ? {
                title: "Client",
                width: "12.85%",
                field: "clientName",
                textAlign: "left",
                rowAlign: "left",
              }:
              {
                title: " ",
                width: "0.1%",
                field: " ",
                textAlign: "left",
                rowAlign: "left",
              },
  {
    title: "Subject",
    width: "12.85%",
    field: "subject",
    textAlign: "left",
    rowAlign: "left",
  },
  {
    title: "Assigned To",
    width: "12.85%",
    field: "assigneeNameto",
    textAlign: "left",
    rowAlign: "left",
  },
 
  {
    title: "Priority",
    width: "12.85%",
    field: "priority",
    textAlign: "left",
    rowAlign: "left",
  },

 
 
  {
    title: "Status",
    width: "12.85%",
    field: "status",
    textAlign: "left",
    rowAlign: "left",
  },
   {
     title: "Action",
     width: "10%",
     field: "action",
     textAlign: "center",
     rowAlign: "center",
     contents:{
       // fetcher:getData,
       id:"assignedTicketId",
       removeValue:"ticketDetails.refNumber",
       url:`/tickets/remove-ticket/`,
       moduleName:"Support Ticket",
       from:`/tickets/support-tickets`,
       editLink:`/tickets/support-tickets/edit/`,
       viewLink:`/tickets/support-tickets/view/`

     }
   },
 ];
 const availableHeaders = [
 
 ];

 const [showExport, setShowExport] = useState(false);
 const [exportValue, setExportValue] = useState({
  status:"",
    startDateTo:"",
    startDateFrom:"",
    endDateFrom:"",
    endDateTo:"",
    priority:"",
    category:"",
    assigneeId:"",
 });
 const ExportFormik = useFormik({
   enableReinitialize: true,
   initialValues: exportValue,
   validateOnChange: false,
   validateOnBlur: false,
   onSubmit: async (value, { resetForm }) => {
     try {
       const response = await axiosInstance.get(
         `/tickets/support-export?status=${value.status}&startDateTo=${value.startDateTo}&startDateFrom=${value.startDateFrom}&endDateFrom=${value.endDateFrom}&endDateTo=${value.endDateTo}&priority=${value.priority}&category=${value.category}&assigneeId=${value.assigneeId}`,
         {
           responseType: "blob",
         }
       );

       const pdfBlob = new Blob([response.data], {
         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
       });

       const link = document.createElement("a");
       link.href = window.URL.createObjectURL(pdfBlob);
      //  link.download = `Support Ticket ${NuDateFormate({
      //    value: new Date(),
      //    format: "DD-MMM-YYYY",
      //  })}.xlsx`;

              link.download = `Support Ticket Report ${formatDate(new Date())}.xlsx`;
      

       document.body.appendChild(link);
       link.click();

       link.parentNode.removeChild(link);
     } catch (error) {
       console.error("Error downloading the PDF:", error);
     }
   },
 });
 const closeFilterDialogebox = () => {
   setShowExport(false);
 };

 const [showEdit, setShowEdit] = useState(false)
 const [showDelete, setShowDelete] = useState(false)
 const [listofNumbers, setListofNumbers] = useState([])
 const [fullList, setFullList] = useState([])

 const selectOneFunction = (value) =>{ 
   let NewId;
   if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
     NewId = listofNumbers.filter(Temp=> Temp !== value);
     setListofNumbers(NewId)
   }else{
     setListofNumbers([...listofNumbers,value])
   }
 }

 const selectMultipleFunction = (e) =>{ 

   if(e.target.checked){
     setListofNumbers(fullList)
   }else{
     setListofNumbers([])
   }
   

     }

     useEffect(()=>{
       setParams({...params,page:page,per_page:pageCount})
      },[page,pageCount])
   

     const closeFilterDialog = () => {
       setShowFilterDialog(false);
     };
 const [showImportModal, setShowImportModal] = useState(false);


 const handleImportClick = () => {
   setShowImportModal(true);
 };

 const closeModal = () => {
   setShowImportModal(false);
 };

 useEffect(()=>{
   let tempArr = []
   data && data.forEach(i=>{
    
     tempArr.push(i?.assignedTicketId)
   });
   setFullList(tempArr)
 },[data])

 const [valueOfSearch,setValuesofSearch] = useState("")
  function searchFunction(e) {

    
    setValuesofSearch(e?.target?.value)
    setParams({ ...params, search: e?.target?.value, page:1 });
    setPage(1)
  }

 // Define your actual API delete function for a single schedule
  const deleteSchedule = async (assignedTicketId) => {
    const response = await axiosInstance.delete(`/tickets/remove-ticket/${assignedTicketId}`);
    return response; // Return the entire Axios response
  };

  

 return (
   <>
   <TicketsLayout 
     setOpen={setShowImportModal}
     searchFun={searchFunction}
     searchValue={valueOfSearch}

     // getData={getData}
     isFilter={filter}
     neededSearch={true}
     newfilter={true}
 officeId={officeId}

     setFilterOpen={setShowFilterDialog}
     ClearFilter={clearFilter}
    //  CreateAccess={GetAccess("testing_and_commisioning_module")}
     ImportAccess={GetAccess("testing_and_commisioning_module")}
           ExportAccess={GetAccess("support_tickets_export")}
           setOpenExport={setShowExport}
           total={totalCount}

     // officeId={officeId}
     // projectID={projectID}
       >


        
{
 screenSize.width <= "786" ?(<>
 <div className=' w-full h-[calc(100vh-205px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
 <MobileSupportTicketIndex
 data={data}
 total={totalCount}
 pageIndex={page}
 setPageIndex={setPage}
 dataCount={pageCount}
 setDataCount={setPageCount}
 officeId={officeId}
 getData={getData}

 />
 </div>
 </>):(<>


   <div className='w-full h-full  '>
  

     <CustomDataTable 
     fetcher={getData}
       data={data} 
       availableHeaders={availableHeaders} 
       defaultHeader={defaultHeader}
       bodyHeight='max-h-[calc(100vh-260px)]'
       height='h-[calc(100vh-160px)]'
       total={totalCount}
       pageIndex={page}
       setPageIndex={setPage}
       dataCount={pageCount}
       setDataCount={setPageCount}
       title='Support Ticket'
       storageName="supportTicketTable"
       selectOneFunction={selectOneFunction}
       setShowDelete={setShowDelete}
       showDelete={showDelete}
       setShowEdit={setShowEdit}
       showEdit={showEdit}
       listofNumbers={listofNumbers}
       hasMultiEdit={true}
       selectMultipleFunction={selectMultipleFunction}
       fullList={fullList}
       getById="assignedTicketId"
       editAccess="support_tickets_edit"      
       deteleAccess="support_tickets_delete" 
       dataLoading={dataLoading}
       searchQuery={params?.search!=""?params?.search:""}
       // dateShow={true}
            hasMultiDelete={true}
                identifierKey="ticketDetails.refNumber"
                deleteSingleItem={deleteSchedule}
       />
   </div>

</>)}

 

       </TicketsLayout>

       {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col mb-4">

                <p className="py-2 px-6 text-m">Start Date</p>
                              <div className="sm:flex justify-between  w-full ">
                               <NuDate
                                label="From "
                                placeholder="dd/mm/yyyy"
                                formik={formik}
                                name="startDateFrom"
                                width="w-full"
                              />
                               <NuDate
                                label="To "
                                placeholder="dd/mm/yyyy"
                                formik={formik}
                                name="startDateTo"
                                width="w-full"
                    min={formik.values.startDateFrom || ""}

                              />
                              </div>
                              <p className="py-2 px-6 text-m">End Date</p>
                              <div className="sm:flex justify-between  w-full ">
                               <NuDate
                                label="From "
                                placeholder="dd/mm/yyyy"
                                formik={formik}
                                name="endDateFrom"
                                width="w-full"
                              />
                               <NuDate
                                label="To "
                                placeholder="dd/mm/yyyy"
                                formik={formik}
                                name="endDateTo"
                                width="w-full"
                    min={formik.values.endDateFrom || ""}

                              />
                              </div>

                <FormikSelectTwo
                                                    label="Assignee"
                                                    Options={user}
                                                    formik={formik}
                                                    placeholder="Choose"
                                                    name="assigneeId"
                                      
                                                    width="w-full"
                                                  />
              <FormikSelectTwo
                         label="Priority"
                         Options={Priority}
                         formik={formik}
                         placeholder="Choose"
                         name="priority"
           
                         width="w-full  "
                         displayProperty={"Priority"}
                         propertyName={"priority"}
                         getFunc={refPriority}
           
                       /> 
              <FormikSelectTwo
                         label="Category"
                         Options={Category}
                         formik={formik}
                         placeholder="Choose"
                         name="category"
           
                         width="w-full  "
                         displayProperty={"Category"}
                         propertyName={"Category_Support_Tickets"}
                         getFunc={refCategory}
           
                       /> 
                      <FormikSelectTwo
                         label="Status"
                         Options={Status}
                         formik={formik}
                         placeholder="Choose"
                         name="status"
           
                         width="w-full"
                         displayProperty={"Status"}
                         propertyName={"Status_Support_Tickets"}
                         getFunc={refStatus}
           
                       /> 
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                               <SubmitButton name="Apply" isLoading={formik.isSubmitting} />

              </div>
            </form>
          </div>
        </div>
      )}

      {showEdit && (
        <MultiEditSupportTicket
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showImportModal && (
        <ImportSupportTicket
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}

{showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in sm:min-w-[50%] min-w-[85%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type =="all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                   <p className="py-2 px-6 text-m">Start Date</p>
                              <div className="sm:flex justify-between  w-full ">
                               <NuDate
                                label="From"
                                placeholder="dd/mm/yyyy"
                                formik={ExportFormik}
                                name="startDateFrom"
                                width="w-full"
                              />
                               <NuDate
                                label="To"
                                placeholder="dd/mm/yyyy"
                                formik={ExportFormik}
                                name="startDateTo"
                                width="w-full"
                    min={ExportFormik.values.startDateFrom || ""}

                              />
                              </div>
                              <p className="py-2 px-6 text-m">End Date</p>
                              <div className="sm:flex justify-between  w-full ">
                               <NuDate
                                label="From "
                                placeholder="dd/mm/yyyy"
                                formik={ExportFormik}
                                name="endDateFrom"
                                width="w-full"
                              />
                               <NuDate
                                label="To "
                                placeholder="dd/mm/yyyy"
                                formik={ExportFormik}
                                name="endDateTo"
                                width="w-full"
                    min={ExportFormik.values.endDateFrom || ""}

                              />
                              </div>

               
              <FormikSelectTwo
                         label="Priority"
                         Options={Priority}
                         formik={ExportFormik}
                         placeholder="Choose"
                         name="priority"
           
                         width="w-full  "
                         displayProperty={"Priority"}
                         propertyName={"priority"}
                         getFunc={refPriority}
           
                       /> 
              <FormikSelectTwo
                         label="Category"
                         Options={Category}
                         formik={ExportFormik}
                         placeholder="Choose"
                         name="category"
           
                         width="w-full  "
                         displayProperty={"Category"}
                         propertyName={"Category_Support_Tickets"}
                         getFunc={refCategory}
           
                       /> 
                      <FormikSelectTwo
                         label="Status"
                         Options={Status}
                         formik={ExportFormik}
                         placeholder="Choose"
                         name="status"
           
                         width="w-full"
                         displayProperty={"Status"}
                         propertyName={"Status_Support_Tickets"}
                         getFunc={refStatus}
           
                       /> 

                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                <SubmitButton name="Export" isLoading={ExportFormik.isSubmitting} />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

       
   </>
 )
}

export default SupportTicketsIndex
